module.exports = __webpack_public_path__ + "img/img95.13aa8cee.jpg";